import Text from "../../Components/Text"
import AdminController from "../../APIController/AdminController"
import React, { useState } from "react";
import Form from "../../Components/Form";
import TextInput from "../../Components/Form/TextInput";
import Checkbox from "../../Components/Form/Checkbox";
import Button from "../../Components/Buttons/Button";

const WorkspaceManagement = ({workspace, afterAction}) => {
    const [name, setName] = useState(workspace.name)
    const [isActive, setIsActive] = useState(workspace.workspaceStatus === "ACTIV")
    const [isTester, setIsTester] = useState(workspace.subscriptionActive)
    const {updateWorkspace, convertOrders} = AdminController()

    const handleFormSubmit = async(e) =>{
        e.preventDefault()
        const workspaceAdminDTO = {
            name: name,
            isActive: isActive,
            isTester: isTester
        }
        await updateWorkspace(workspace.id, workspaceAdminDTO)
        afterAction()
    }

    return(
        <Form onSubmitAction={handleFormSubmit} submitButtonText={"Workspaceeinstellungen Speichern"}>
            <Text type="maintitle" classNames={"flex text-center justify-center"}>{`${workspace.name} bearbeiten`}</Text>
            <TextInput attribute={name} id={"name"} label={"Name"} placeholder={"Name"} action={(e) => setName(e.target.value)} />
            <Checkbox attribute={isActive} id={"isActive"} label={"Aktiv?"} required={false} action={(e) => setIsActive(e.target.checked)} />
            <Checkbox attribute={isTester} id={"isTester"} label={"Gratis Tester?"} required={false} action={(e) => setIsTester(e.target.checked)} />
            <Button text={"Konvertiere Bestellungsformat"} onClickAction={() => convertOrders(workspace.id)}/>
        </Form>
    )
}
export default WorkspaceManagement